import logo from './logo.svg';
import './App.css';

import { NovaTopHeader } from './Tophear'
import { NovaHeader } from './Head'

import { default as RCImageGallery } from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import ImageView from './comview/ImageView';


// dòng phía dưới nằm dưới tất cả dòng import
const ImageGalleryCmp = RCImageGallery


function App() {

  // lưu ý folder img nằm trong thư mục public của dự án :
  let n_img = 6;
  let galleries = [];
  let ext_img = ".png";
  let url_img = "/laptrinhgiaoduc/img/";
  for (var ig = 0; ig < n_img; ig++) {

    let p1 = { original: url_img + ig.toString() + ext_img, thumbnail: url_img + ig.toString() + ext_img }
    galleries.push(p1);
  }
  let props = {
    items: galleries,
  }


  return (
    <div className="App">

      <NovaTopHeader />
      <NovaHeader />
      <ImageGalleryCmp {...props} autoPlay />
      <div className="centered-div" >
        <div style={{ width: '50%' }}>
          Lập trình giáo dục là một app dạy vè code viết các vòng lặp, lệnh điều kiện, tư duy thuật toán cho học sinh, sinh viên, sử dụng trong dạy học tư duy,
          với các cấu trúc dữ liệu mảng, biến, hàm, và constructor trừu tượng, Khái niệm đối tượng cho học sinh, sinh viên. chúng tôi sẽ cố gắng phát triển tư
          duy cấu trúc lập trình, và ngày càng hoàn thiện hơn để hổ trợ dạy học cho các giáo viên. Được thiết kế chạy trên điện thoại, dễ dàng mang theo sử dụng
          bất kể đâu, nằm, ngồi đề có thể viêt code tư duy tốt.
          Bạn có thê liên hệ email hổ trợ : devhai@icloud.com
          Bên dưới là các đoạn code mẩu :

          <pre>
        {`xx = 9;
if (xx > 7) {
  xx = 6;
}
a = 9;  
for (i = 0; i < xx; i++) {
  a += i;
}
output(a);

while (xx < a) {
  xx += 1;
}
output(xx);

do {
  xx += 1;
} while (xx < 50);
output(xx);

switch (xx) {
  case 5:
    output(5);
    break;
  case 50:
    output(54);
    break;
  default:
    break;
}

cons = constructor_new("
aa = 5 + con1;
bb = 'Nguyen Van Teo';
cc = 5*aa + con2;
mystruc = {
  a : 66,
  b : 88,
}
tong = function('
  var t = ar1 + ar2 ;
  result = t;
  '
);

","conmot");
////////

obj = obj_constructor(cons,22,5);
obj2 = obj_constructor(cons,88,3);

conhai = constructor_inheritance("
bt = 'an com ngon';

"
,"conmot");

obj3 = obj_constructor(conhai,5,11);
output(obj3.bt);
`}
      </pre>

        </div>
      </div>


    </div>
  );
}

export default App;
